var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.isEditMode
              ? "Cập nhật gói học phí"
              : "Thêm mới gói học phí",
            size: "lg",
            "cancel-text": "Hủy",
            "confirm-text": "Lưu lại",
            "confirm-loading": _vm.loading,
            "use-panel": false,
            top: "6vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            confirm: _vm.handleSubmit,
            cancel: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "pfd-help-entry mb-3" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content:
                      "Xem hướng dẫn chi tiết cách thiết lập và gia hạn gói học phí",
                    placement: "top",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-question",
                        plain: "",
                        size: "small",
                      },
                      on: { click: _vm.openGuideDialog },
                    },
                    [_vm._v("\n          Hướng dẫn thiết lập gói\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              ref: "dataForm",
              staticClass: "sk-dialog-content",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.formRules,
                "label-width": "210px",
                "label-position": "left",
              },
            },
            [
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-collection" }),
                    ]),
                    _c("div", { staticClass: "pfd-panel-text" }, [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thông tin chung của gói"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "\n              Mỗi học sinh có chu kỳ học phí riêng bắt đầu từ ngày học sinh tham gia vào gói.\n            "
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "name" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Tên gói học phí\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Tên hiển thị của gói học phí (ví dụ: Gói học phí bán trú 6 tháng, Gói tiếng Anh tăng cường...)",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question pfd-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Nhập tên gói học phí...",
                                  maxlength: "255",
                                  "show-word-limit": "",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.dataForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "name", $$v)
                                  },
                                  expression: "dataForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "maxMembers" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Số học sinh tối đa\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Giới hạn số học sinh tối đa có thể tham gia gói này. Để trống nếu không giới hạn sĩ số.",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question pfd-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 1,
                                  step: 1,
                                  placeholder: "Không giới hạn",
                                  "controls-position": "right",
                                },
                                model: {
                                  value: _vm.dataForm.maxMembers,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "maxMembers", $$v)
                                  },
                                  expression: "dataForm.maxMembers",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "description" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Mô tả\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Ghi chú ngắn về đối tượng áp dụng, quyền lợi hoặc điều kiện của gói học phí (tối đa 500 ký tự)",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question pfd-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder:
                                    "Nhập mô tả gói học phí, ví dụ: Áp dụng cho học sinh khối Mầm non, bao gồm tiền ăn và học phí hè...",
                                  maxlength: "500",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.dataForm.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "description", $$v)
                                  },
                                  expression: "dataForm.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-money" }),
                    ]),
                    _c("div", { staticClass: "pfd-panel-text" }, [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Cách tính và thu học phí"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Thiết lập đơn vị tính và số lượng đơn vị cho mỗi lần thu học phí"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "billingCycle" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Đơn vị tính học phí\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Chọn đơn vị dùng để tính học phí. Ví dụ chọn Hàng tháng nghĩa là học phí được tính theo tháng.",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question pfd-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  on: { change: _vm.handleBillingCycleChange },
                                  model: {
                                    value: _vm.dataForm.billingCycle,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataForm,
                                        "billingCycle",
                                        $$v
                                      )
                                    },
                                    expression: "dataForm.billingCycle",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "Hàng tháng",
                                      value: "MONTHLY",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Hàng năm",
                                      value: "YEARLY",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Hàng ngày",
                                      value: "DAILY",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Thu một lần (không lặp lại)",
                                      value: "ONE_TIME",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      ["MONTHLY", "YEARLY", "DAILY"].includes(
                        _vm.dataForm.billingCycle
                      )
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "cycleDuration" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Số đơn vị thu mỗi lần\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Số đơn vị được thu trong một lần. Ví dụ Hàng tháng và số 3 nghĩa là mỗi lần thu 3 tháng.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question pfd-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1742739599
                                  ),
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: { min: 1, step: 1 },
                                    model: {
                                      value: _vm.dataForm.cycleDuration,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataForm,
                                          "cycleDuration",
                                          $$v
                                        )
                                      },
                                      expression: "dataForm.cycleDuration",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "pfd-preview-banner pfd-preview-banner--billing mt-2",
                    },
                    [
                      _c("i", { staticClass: "el-icon-info mr-1" }),
                      _c("span", { staticClass: "pfd-preview-label" }, [
                        _vm._v("Diễn giải cách thu:"),
                      ]),
                      _c("strong", { staticClass: "pfd-preview-text ml-1" }, [
                        _vm._v(_vm._s(_vm.billingSummaryText)),
                      ]),
                    ]
                  ),
                  _vm.dataForm.billingCycle !== "ONE_TIME"
                    ? _c("div", { staticClass: "pfd-section-desc mt-2" }, [
                        _c("i", { staticClass: "el-icon-user mr-1" }),
                        _c("strong", [_vm._v("Ví dụ:")]),
                        _vm._v(" Nếu học sinh tham gia gói vào ngày "),
                        _c("strong", [_vm._v("01/08/2026")]),
                        _vm._v(
                          ",\n          chu kỳ đầu tiên sẽ là\n          "
                        ),
                        _c("strong", [
                          _vm._v(
                            "01/08/2026 → " + _vm._s(_vm.exampleCycleEndText)
                          ),
                        ]),
                        _vm._v(
                          ". Chu kỳ tiếp theo bắt đầu ngay ngày hôm sau khi chu kỳ hiện tại kết thúc.\n        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-refresh" }),
                    ]),
                    _c("div", { staticClass: "pfd-panel-text" }, [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Tự động gia hạn khi hết hạn"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Cấu hình nhắc hạn và gia hạn tự động (chỉ áp dụng cho học sinh được đăng ký)"
                        ),
                      ]),
                    ]),
                    _vm.dataForm.billingCycle === "ONE_TIME"
                      ? _c("div", { staticClass: "pfd-locked-badge" }, [
                          _c("i", { staticClass: "el-icon-lock" }),
                          _vm._v(
                            ' Đã khóa (Gói "Thu một lần" không áp dụng gia hạn)\n          '
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "pfd-section-desc mb-3" }, [
                    _c("i", { staticClass: "el-icon-info mr-1 text-primary" }),
                    _vm._v(
                      "\n          Khi bật, hệ thống tự động gia hạn theo đúng cách tính học phí của gói. Mỗi lần gia hạn sẽ tạo một chu kỳ mới. Nhân viên cần chọn học sinh được gia hạn trong danh sách riêng.\n        "
                    ),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "autoRenew" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Cho phép tự động gia hạn\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Bật chính sách gia hạn cho gói. Nhân viên vẫn phải chọn học sinh được phép gia hạn ở danh sách riêng.",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question pfd-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  disabled:
                                    _vm.dataForm.billingCycle === "ONE_TIME",
                                  "active-text": "Bật",
                                  "inactive-text": "Tắt",
                                },
                                on: { change: _vm.handleAutoRenewChange },
                                model: {
                                  value: _vm.dataForm.autoRenew,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "autoRenew", $$v)
                                  },
                                  expression: "dataForm.autoRenew",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "renewalNoticeDays" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Nhắc lần đầu trước hạn (ngày)\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Số ngày trước khi hết hạn sẽ bắt đầu nhắc. Ví dụ: 10 nghĩa là nhắc trước 10 ngày khi chu kỳ sắp hết hạn.",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question pfd-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 0,
                                  step: 1,
                                  disabled:
                                    _vm.dataForm.billingCycle === "ONE_TIME" ||
                                    !_vm.dataForm.autoRenew,
                                },
                                model: {
                                  value: _vm.dataForm.renewalNoticeDays,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "renewalNoticeDays",
                                      $$v
                                    )
                                  },
                                  expression: "dataForm.renewalNoticeDays",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "renewalReminderFrequencyDays" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Nhắc lại mỗi (ngày/lần)\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Sau lần nhắc đầu, hệ thống sẽ tiếp tục nhắc lại theo tần suất này. Ví dụ: 3 nghĩa là nhắc lại mỗi 3 ngày. Để trống nếu chỉ nhắc một lần.",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question pfd-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 1,
                                  step: 1,
                                  placeholder: 0,
                                  disabled:
                                    _vm.dataForm.billingCycle === "ONE_TIME" ||
                                    !_vm.dataForm.autoRenew,
                                },
                                model: {
                                  value:
                                    _vm.dataForm.renewalReminderFrequencyDays,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "renewalReminderFrequencyDays",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "dataForm.renewalReminderFrequencyDays",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.dataForm.autoRenew &&
                  _vm.dataForm.renewalNoticeDays > 0 &&
                  _vm.dataForm.billingCycle !== "ONE_TIME"
                    ? _c("div", { staticClass: "pfd-reminder-example" }, [
                        _c("i", { staticClass: "el-icon-bell mr-1" }),
                        _c("strong", [_vm._v("Ví dụ lịch nhắc:")]),
                        _vm._v("\n          Nếu chu kỳ hết hạn ngày "),
                        _c("strong", [_vm._v("31/10/2026")]),
                        _vm._v(", nhắc lần đầu vào\n          "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.exampleFirstReminderText)),
                        ]),
                        _vm.dataForm.renewalReminderFrequencyDays >= 1
                          ? _c("span", [
                              _vm._v("\n            → nhắc tiếp mỗi "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.dataForm.renewalReminderFrequencyDays
                                  ) + " ngày/lần"
                                ),
                              ]),
                              _vm._v(" cho đến khi hết hạn\n          "),
                            ])
                          : _vm._e(),
                        _vm._v(".\n        "),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "pfd-preview-banner pfd-preview-banner--renewal mt-2",
                    },
                    [
                      _c("i", { staticClass: "el-icon-refresh mr-1" }),
                      _c("span", { staticClass: "pfd-preview-label" }, [
                        _vm._v("Chính sách gia hạn:"),
                      ]),
                      _c("strong", { staticClass: "pfd-preview-text ml-1" }, [
                        _vm._v(_vm._s(_vm.renewalSummaryText)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "pfd-summary-card mb-2" }, [
                _c("div", { staticClass: "pfd-summary-title" }, [
                  _c("i", {
                    staticClass: "el-icon-document-checked mr-1 text-primary",
                  }),
                  _vm._v(" Tổng hợp cấu hình gói học phí\n        "),
                ]),
                _c("div", { staticClass: "pfd-summary-grid" }, [
                  _c("div", { staticClass: "pfd-summary-item" }, [
                    _c("span", { staticClass: "pfd-summary-lbl" }, [
                      _vm._v("1. Cách tính & thu:"),
                    ]),
                    _c("span", { staticClass: "pfd-summary-val" }, [
                      _vm._v(_vm._s(_vm.billingSummaryText)),
                    ]),
                  ]),
                  _c("div", { staticClass: "pfd-summary-item" }, [
                    _c("span", { staticClass: "pfd-summary-lbl" }, [
                      _vm._v("2. Tự động gia hạn:"),
                    ]),
                    _c("span", { staticClass: "pfd-summary-val" }, [
                      _vm._v(_vm._s(_vm.renewalSummaryText)),
                    ]),
                  ]),
                  _vm.dataForm.autoRenew && _vm.dataForm.renewalNoticeDays >= 0
                    ? _c("div", { staticClass: "pfd-summary-item" }, [
                        _c("span", { staticClass: "pfd-summary-lbl" }, [
                          _vm._v("3. Nhắc hạn:"),
                        ]),
                        _c("span", { staticClass: "pfd-summary-val" }, [
                          _vm._v(_vm._s(_vm.reminderSummaryText)),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("package-guide-dialog", { ref: "guideDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }